/**
 * Options for which types of logging to show.
 * See `loggingConfigs.ts` for correspondence to log level CLI options.
 */
export interface TaskReporterLogLevelOptions {
  /** Show console.log messages. */
  showConsoleLog?: boolean;

  /** Show console.warn messages. */
  showConsoleInfo?: boolean;

  /** Show console.warn messages. */
  showConsoleWarn?: boolean;

  /** Show console.error messages. */
  showConsoleError?: boolean;

  /** Show console.debug messages. */
  showConsoleDebug?: boolean;

  /** Show errors that occur during task execution. */
  showErrors?: boolean;

  /** Show product info header. */
  showProductInfo?: boolean;

  /** Show summary of tasks once the `complete` method has been called. */
  showSummary?: boolean;

  /** Log when each task starts. */
  showStarted?: boolean;

  /** Show tasks that are completed above the sticky summary, as they complete. */
  showCompleted?: boolean;

  /**
   * Show tasks that are pending (as sticky tasks below the summary).
   * If `plainTextMode` is set, `showPending` implicitly sets `showStarted`, since otherwise
   * task starts wouldn't be shown at all.
   */
  showPending?: boolean;

  /** Show heap usage. */
  showHeapUsage?: boolean;

  /**
   * Show additional task details (`TaskReporterTaskResult.details`) when a task completes.
   * This is enabled by default with verbose logging.
   */
  showTaskDetails?: boolean;

  /**
   * Show extended details (`TaskReporterTaskResult.extended`) when a task completes.
   *
   * for tasks. This is useful for showing additional
   * information about a task, such as extended metadata for a task. This should
   * show in verbose logging.
   */
  showTaskExtended?: boolean;
}
